import React, { Component } from 'react';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import lazyLoad from '../../assets/js/lazy-load';
import ImageHelper from '../../helpers/ImageHelper';
import BackButton from '../shared/BackButton';

class Banner extends Component {
  constructor(props) {
    super(props);
    this.state = { image: null };
  }

  componentDidMount() {
    lazyLoad(document.getElementsByClassName('lazy-load'));
  }

  componentDidUpdate() {
    lazyLoad(document.getElementsByClassName('lazy-load'));
  }

  openImage(index) {
    this.setState({
      image: ImageHelper.getImageURL(this.props.images[index], '?func=crop&w=400&h=400')
    });
  }

  closeImage() {
    this.setState({ image: null });
  }

  renderImages(images) {
    return images.map((image) => {
      return (
        <img
          className="lazy-load"
          src={ImageHelper.getImageURL(image, '?func=crop&w=400&h=400')}
          data-src={ImageHelper.getImageURL(image, '?func=crop&w=400&h=400')}
          alt={''}
          key={image}
        />
      );
    });
  }

  render() {
    let { images } = this.props;
    return (
      <React.Fragment>
        {this.props.goBack && [
          <BackButton goBack={this.props.goBack} key="back-buttom" />,
          <div className="item-banner" key="carousel">
            <div className="banner-wrapper">
              <Carousel
                transitionTime={50}
                onClickItem={this.openImage.bind(this)}
                infiniteLoop={images.length > 1}
                showArrows={false}
                showStatus={false}
                showThumbs={false}
              >
                {this.renderImages(images)}
              </Carousel>
            </div>
            {this.state.image && (
              <Lightbox
                showImgCount={false}
                isOpen={this.state.image !== null}
                onCloseRequest={this.closeImage.bind(this)}
                mainSrc={this.state.image}
              />
            )}
          </div>
        ]}
        {!this.props.goBack && [
          <div className="item-banner" key="carousel">
            <div className="banner-wrapper">
              <Carousel
                transitionTime={50}
                onClickItem={this.openImage.bind(this)}
                infiniteLoop={images.length > 1}
                showArrows={false}
                showStatus={false}
                showThumbs={false}
              >
                {this.renderImages(images)}
              </Carousel>
            </div>

            {this.state.image && (
              <Lightbox
                showImgCount={false}
                isOpen={this.state.image !== null}
                onCloseRequest={this.closeImage.bind(this)}
                mainSrc={this.state.image}
              />
            )}
          </div>
        ]}
      </React.Fragment>
    );
  }
}
export default Banner;
